module.exports = __webpack_public_path__ + "img/sport-46-@3x.0b04c340.png";